import {
  ComponentProps,
  forwardRef,
  useImperativeHandle,
} from "react";
import { SubmitHandler, useForm } from "react-hook-form";

import { Button } from "@design-system/Button/Button";
import { FieldGroup } from "@design-system/FieldGroup/FieldGroup";
import { Form } from "@design-system/Form/Form";
import { TextField } from "@design-system/TextField/TextField";

export type OrganizationFilterFormValues = {
  nameSearch?: string | undefined;
  stytchOrganizationIdSearch?: string | undefined;
};

export type OrganizationFilterFormRef = {
  getCurrentValues: () => OrganizationFilterFormValues;
};

type Props = {
  submitText?: string;
  onFilterChange: SubmitHandler<OrganizationFilterFormValues>;
  values: OrganizationFilterFormValues;
  errorsAPI?: ComponentProps<typeof Form>["errorsAPI"];
  disabled?: boolean;
  withSubmitButton?: boolean;
};

export const OrganizationFilterForm = forwardRef<OrganizationFilterFormRef, Props>(
  ({ onFilterChange, values, errorsAPI }, ref) => {
    const { handleSubmit, setValue, watch, getValues } =
      useForm<OrganizationFilterFormValues>({
        values: {
          nameSearch: values.nameSearch ?? undefined,
          stytchOrganizationIdSearch: values.stytchOrganizationIdSearch ?? undefined,
        },
      });

    const nameSearch = watch("nameSearch");
    const stytchOrganizationIdSearch = watch("stytchOrganizationIdSearch");

    useImperativeHandle(
      ref,
      () => ({
        getCurrentValues: () => getValues(),
      }),
      [getValues],
    );

    return (
      <Form onSubmit={handleSubmit(onFilterChange)} errorsAPI={errorsAPI}>
        <FieldGroup label="Organization name">
          <TextField
            placeholder="Search by organization name..."
            value={nameSearch ?? ""}
            onChange={(e) =>
              setValue("nameSearch", e.target.value || undefined, {
                shouldDirty: true,
              })
            }
          />
        </FieldGroup>

        <FieldGroup label="Stytch Organization ID">
          <TextField
            placeholder="Search by Stytch organization ID..."
            value={stytchOrganizationIdSearch ?? ""}
            onChange={(e) =>
              setValue("stytchOrganizationIdSearch", e.target.value || undefined, {
                shouldDirty: true,
              })
            }
          />
        </FieldGroup>

        <Button type="submit" style={{ display: "none" }} />
      </Form>
    );
  },
);